import { createContext } from 'react';

import { User } from '@totem/components/users/container/types';

interface Context {
  internalUsers: User[];
  searchTerm: string;
  page: number;
  pageSize: number;
  onRefresh: () => void;
  setSearchTerm: (searchTerm: string) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
}

export default createContext<Context>({
  internalUsers: [],
  searchTerm: '',
  page: 1,
  pageSize: 50,
  onRefresh: () => {},
  setSearchTerm: () => {},
  setPage: () => {},
  setPageSize: () => {},
});
